import type { AssetResourceEntry } from '@atlaskit/react-ufo/common';
const allAtlassian = ({ label }: AssetResourceEntry): boolean => {
	if (
		label.startsWith('atlaskit') ||
		label.startsWith('atlassian') ||
		label.startsWith('atlassiansox')
	) {
		return true;
	}
	return false;
};

const domContentLoadedEventEnd = (() => {
	const navigationEntry =
		typeof window !== 'undefined' && window.performance?.getEntriesByType?.('navigation')?.[0];
	if (
		typeof PerformanceNavigationTiming !== 'undefined' &&
		navigationEntry instanceof PerformanceNavigationTiming
	) {
		return navigationEntry.domContentLoadedEventEnd;
	}
	return null;
})();

const preloaded = ({ entry }: AssetResourceEntry): boolean => {
	const isBeforeSSR =
		domContentLoadedEventEnd !== null && entry.startTime < domContentLoadedEventEnd;
	if (entry.type === 'link' && isBeforeSSR) {
		return true;
	}
	return false;
};

export const assetsClassification = {
	all: true,
	allAtlassian,
	preloaded,
};
